import { Box } from "@chakra-ui/react";
import React from "react";
import img from "../assets/OR_6862.png";
import star from "../assets/Portal.png";
import ImgOptimized from "./ImgOptimized";

function HomeBannerLayout() {
  return (
    <div className="h-[86%] mt-16 flex gap-4 w-[90%] justify-between ">
      <div className="flex flex-col gap-3 w-[20%]">
        <div className="h-[10%]">
          <ImgOptimized
            src={star}
            className="rounded-xl float-end h-full object-cover"
            alt=""
          />
        </div>
        <ImgOptimized
          src={img}
          className="rounded-xl w-full h-[60%] object-cover"
          alt=""
        />
        <ImgOptimized
          src={img}
          className="rounded-xl w-full h-[28%] object-cover"
          alt=""
        />
      </div>

      <div className="flex flex-col gap-3 flex-1 bg-green-300">
        <h2>
          Turning Visions
          <br /> into Spaces
        </h2>
      </div>

      <div className="flex flex-col gap-3 w-[20%] ">
        <ImgOptimized
          src={img}
          className="rounded-xl w-full h-[70%] object-cover"
          alt=""
        />
        <ImgOptimized
          src={img}
          className="rounded-xl w-full h-[28%] object-cover"
          alt=""
        />
      </div>
    </div>
  );
}

export default HomeBannerLayout;
